// extracted by mini-css-extract-plugin
export var brand = "_ak-9";
export var compact = "_ak-6";
export var extraSmall = "_ak-7";
export var icon = "_ak-0";
export var large = "_ak-4";
export var light = "_ak-1";
export var medium = "_ak-5";
export var outline = "_ak-b";
export var primaryDark = "_ak-a";
export var primaryLight = "_ak-8";
export var primaryModern = "_ak-c";
export var success = "_ak-2";
export var successSolid = "_ak-3";